class LandingProductDoubleSection extends HTMLElement {
  constructor() {
    super()
    this.stepBlocks = this.querySelectorAll('[data-step]');
    this.finalBlock = this.querySelector('.final-step__list');
    this.productsElements = this.querySelectorAll('[data-step-name="product"]');
    this.addButton = this.querySelector('.final-step__product__button');
    this.subscriptionPopup = this.querySelector('subscription-popup');
    this.clickedBlock = null;
    this.isFinalBlock = false;
    this.layout = this.getAttribute('data-layout');
    this.purchaseType = this.dataset.purchaseType;
    this.isOpenedByDefault = this.hasAttribute('data-is-opened-by-default');
    this.isInitialized = false;

    this.clearCart()

    this.stepBlocks.forEach(block => {
      block.addEventListener('click', () => {
        this.clickedBlock = block
        this.highlightBlock();
      })
    })

    this.addButton?.addEventListener('click', this.handleCheckoutButtonClick.bind(this))
  }

  connectedCallback() {
    if (this.isOpenedByDefault) {
      const currentActiveProduct = this.querySelector('[data-step-name="product"].step-block__item--active');
      
      if (currentActiveProduct) {
        this.clickedBlock = currentActiveProduct;
        this.highlightBlock();
      }
      
    }
  }

  clearCart() {
    return fetch('/cart/clear.js')
  }

  handleCheckoutButtonClick(event) {
    if (this.shouldShowSubscriptionPopup()) {
      event.preventDefault();
      event.stopPropagation();
      this.openSubscriptionPopup();
      return;
    }

    this.clearCartAndAddToCart(event);
  }

  shouldShowSubscriptionPopup() {
    if (!this.subscriptionPopup || this.purchaseType !== 'onetime') return false;

    const object = JSON.parse(this.querySelector('#landing-product__object').innerHTML).settings || {};
    return Boolean(object.enable_product_subscription_popup);
  }

  openSubscriptionPopup() {
    this.subscriptionPopup?.dispatchEvent(new CustomEvent('subscription-popup:open', {
      detail: this.getActiveOfferContext(),
      bubbles: false,
    }));
  }

  clearCartAndAddToCart(event = new Event('click')) {
    event.preventDefault();
    event.stopPropagation();
    this.clearCart()
      .then(() => {
        this.addToCart()
      })
  }

  highlightBlock() {
    let currentStep = this.clickedBlock.dataset.step
    let currentStepName = this.clickedBlock.dataset.stepName
    let prevActiveBlock = this.querySelector(`[data-step="${currentStep}"].step-block__item--active`)

    if (currentStepName === 'type' && !this.isOpenedByDefault) {
      this.querySelectorAll('.step-block__item--active').forEach(activeElement => {
        activeElement.classList.remove('step-block__item--active')
        this.querySelector('[data-step-name="product"]')?.closest('.step-block')?.classList.remove('step-block--active')
      })
      this.isFinalBlock = false
    }

    if (currentStepName === 'roast') {
      this.isFinalBlock = false
    }

    if (prevActiveBlock) {
      prevActiveBlock.classList.remove('step-block__item--active')
    }
    this.clickedBlock.classList.add('step-block__item--active')

    if (currentStepName === 'product') {
      let productItem = this.querySelector('[data-step-name="product"].step-block__item--active')
      let prevProduct = this.querySelector('.final-step__product--active')

      if (prevProduct) {
        prevProduct.classList.remove('final-step__product--active')
      }
      productItem.classList.add('final-step__product--active')

      this.setButtonPrice(productItem);
    }

    this.openNextStep()
  }

  openNextStep() {
    let nextStep = +this.clickedBlock.dataset.step + 1
    let nextStepWrapper = this.querySelector(`[data-step="${nextStep}"]`)
    let nextStepName = nextStepWrapper?.dataset?.stepName;

    this.setAttribute('data-current-step', +nextStep);
    this.previousStepButton?.classList.toggle('active', nextStep !== 1)

    this.isFinalBlock ? this.showFinalBlock() : this.hideFinalBlock()

    if (nextStepWrapper && nextStepName == "roast") {
      this.openRoastStep(nextStepWrapper);
    } else if (nextStepWrapper && nextStepName == "product") {
      this.openProductStep(nextStepWrapper);
    } else {
      this.showFinalBlock()
    }
  }

  openRoastStep(nextStepWrapper) {
    if (this.clickedBlock.dataset.variant == "Default Title") {
      nextStepWrapper.closest('.step-block').classList.add("step-block--default-variant-active")
      nextStepWrapper.closest('.step-block').classList.remove("step-block--active")
    } else {
      nextStepWrapper.closest('.step-block').classList.add('step-block--active')
      nextStepWrapper.closest('.step-block').classList.remove("step-block--default-variant-active")
    }
    if (!this.isFinalBlock && this.layout !== 'quiz') {
      const activeNextBlock = this.clickedBlock.closest('.step-block')?.nextElementSibling;
      if (!activeNextBlock) return;
      window.scrollTo({ top: activeNextBlock.offsetTop - 150, behavior: 'smooth' });
    }
  }

  openProductStep(nextStepWrapper) {
    let activeRoastId = this.querySelector('[data-step-name="roast"].step-block__item--active')?.dataset.product

    this.productsElements.forEach(productElement => {
      if (productElement.dataset.finalProductId === activeRoastId || this.productsElements.length == 2) {
        productElement.classList.remove('step-block__item--hidden')
        if (productElement.dataset.quantity == '6' || productElement.dataset.quantity == '4') {
          if (!this.isFinalBlock) productElement.click();
        }

        const variantTitleElement = productElement.querySelector('.final-step__product__variant');
        if (variantTitleElement) {
          const variantBlock = this.querySelector('.step-block__item--active[data-variant]');
          const selectedVariant = variantBlock?.dataset.variant != 'Default Title' ? variantBlock.dataset.variant : '';
          
          variantTitleElement.innerHTML = selectedVariant;
        }
      } else {
        productElement.classList.add('step-block__item--hidden')
        productElement.classList.remove('step-block__item--active', 'final-step__product--active')
      }
    })

    nextStepWrapper.closest('.step-block').classList.add('step-block--active')
    if (!this.isFinalBlock && this.layout !== 'quiz') {
      const activeNextBlock = this.clickedBlock.closest('.step-block')?.nextElementSibling;
      window.scrollTo({ top: activeNextBlock.offsetTop - 150, behavior: 'smooth' });
    }
  }

  setButtonPrice(productItem) {
    const buttonComparePriceElement = this.querySelector('.final-step__product__button-price .price__compare');
    const buttonOriginalPriceElement = this.querySelector('.final-step__product__button-price .price__original');
    const priceWrapper = productItem.querySelector('.price__wrapper');
    
    const productOriginalPrice = priceWrapper?.dataset.priceOriginal || productItem.querySelector('.price__original')?.textContent
    const productComparePrice = priceWrapper?.dataset.priceCompare || productItem.querySelector('.price__compare')?.textContent

    buttonComparePriceElement.innerText = productComparePrice ? productComparePrice : '';
    buttonOriginalPriceElement.innerText = productOriginalPrice;
  }

  showFinalBlock() {
    this.setAttribute('data-current-step', 'final');

    this.isFinalBlock = true
    this.finalBlock.classList.add('active')

    if (this.layout !== 'quiz') {
      if (!this.isInitialized && this.isOpenedByDefault) {
        this.isInitialized = true;
      } else {
        setTimeout(() => { //setTimeout is used to ensure the final block has right position after transition
          window.scrollTo({ top: window.innerWidth < 768 ? this.finalBlock.offsetTop - 450 : this.finalBlock.offsetTop - 600, behavior: 'smooth' });
        }, 201)
      }
    }
  }

  hideFinalBlock() {
    if (this.isOpenedByDefault) return;

    this.finalBlock.classList.remove('active')
  }

  getActiveOfferContext() {
    let object = JSON.parse(this.querySelector('#landing-product__object').innerHTML).settings
    let activeProduct = this.querySelector('.final-step__product--active')
    if (!activeProduct) return { settings: object };

    let productId = activeProduct.dataset.finalProductId
    let selectedVariant = this.querySelector('.step-block__item--active[data-variant]') ? this.querySelector('.step-block__item--active[data-variant]').dataset.variant : 'Default Title'
    let products = object.products
    let variantId;
    let currentProduct
    for (let product = 0; product < object.products.length; product++) {
      if (products[product].id == productId) {
        currentProduct = products[product]
        for (let i = 0; i < currentProduct.variants.length; i++) {
          if (currentProduct.variants[i].title == selectedVariant) {
            variantId = currentProduct.variants[i].id
            break
          }
        }
      }
    }

    const priceWrapper = activeProduct.querySelector('.price__wrapper');
    const priceOriginal = priceWrapper?.dataset.priceOriginal || activeProduct.querySelector('.price__original')?.textContent?.trim() || '';
    const priceCompare = priceWrapper?.dataset.priceCompare || activeProduct.querySelector('.price__compare')?.textContent?.trim() || '';
    const quantity = Number(activeProduct.dataset.quantity);
    let defaultDiscountCode = quantity > 3 && currentProduct.type != 'Pod' ? object.discount_code_big : object.discount_code;
    if (object.use_separate_pods_discounts && currentProduct.type == 'Pod') {
      defaultDiscountCode = quantity > 2 ? object.discount_code_pods_big : object.discount_code_pods;
    }
    const subscriptionDiscountCode = quantity > 3 && currentProduct.type != 'Pod'
      ? object.subscription_popup_discount_code_big
      : object.subscription_popup_discount_code;
    const firstVisitedPage = localStorage.getItem('first-visited-page');

    return {
      settings: object,
      product: currentProduct,
      productId,
      productType: currentProduct?.type,
      variantId: Number(variantId),
      variantTitle: selectedVariant,
      quantity,
      priceOriginal,
      priceCompare,
      discountCode: defaultDiscountCode,
      subscriptionDiscountCode,
      checkoutUrl: defaultDiscountCode ? `/checkout?discount=${encodeURIComponent(defaultDiscountCode)}` : '/checkout',
      subscriptionCheckoutUrl: subscriptionDiscountCode ? `/checkout?discount=${encodeURIComponent(subscriptionDiscountCode)}` : '/checkout',
      landingUniqProp: window.landing_uniq_prop || '',
      firstVisitedPage,
    };
  }

  addToCart() {
    let object = JSON.parse(this.querySelector('#landing-product__object').innerHTML).settings
    let activeProduct = this.querySelector('.final-step__product--active')
    let productId = activeProduct.dataset.finalProductId
    let selectedVariant = this.querySelector('.step-block__item--active[data-variant]') ? this.querySelector('.step-block__item--active[data-variant]').dataset.variant : 'Default Title'
    let products = object.products
    let variantId;
    let currentProduct
    for (let product = 0; product < object.products.length; product++) {
      if (products[product].id == productId) {
        currentProduct = products[product]
        for (let i = 0; i < currentProduct.variants.length; i++) {
          if (currentProduct.variants[i].title == selectedVariant) {
            variantId = currentProduct.variants[i].id
            break
          }
        }
      }
    }

    const items = [{
      id: Number(variantId),
      quantity: Number(activeProduct.dataset.quantity)
    }];

    const mainItem = items[0];
    const mainProperties = {};

    if (object.subscription_name) {
      let subscriptionGroups = currentProduct?.selling_plan_groups[0]?.selling_plans || [];
      for (let i = 0; i < subscriptionGroups.length; i++) {
        if (subscriptionGroups[i].name == object.subscription_name) {
          mainItem.selling_plan = subscriptionGroups[i].id
          break
        }
      }
    }

    if (window.landing_uniq_prop != '') {
      mainProperties._landingSubscription = window.landing_uniq_prop
    }
    if (localStorage.getItem('first-visited-page')) {
      mainProperties._first_visited_page = localStorage.getItem('first-visited-page');
    }
    if (Object.keys(mainProperties).length) {
      mainItem.properties = mainProperties;
    }

    const atcObject = { items };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(atcObject)
    })
      .then(() => {
        let discountCode = activeProduct.dataset.quantity > 3 && currentProduct.type != 'Pod' ? object.discount_code_big : object.discount_code
        if (object.use_separate_pods_discounts && currentProduct.type == 'Pod') {
          discountCode = activeProduct.dataset.quantity > 2 ? object.discount_code_pods_big : object.discount_code_pods;
        }

        window.location.href = object.discount_code ? `/checkout?discount=${discountCode}` : '/checkout'
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

customElements.define('landing-product-double', LandingProductDoubleSection);

class LandingProductDoubleSectionNew extends LandingProductDoubleSection {
  constructor() {
    super()

    this.previousStepButton = this.querySelector('.landing-product__previous-step-button')
    this.stepBlocksContainer = this.querySelector('.landing-product__steps-container')
    this.stepProgressWrapper = this.querySelector('.landing-product__steps-progress__wrapper')
    this.progressStepItems = Array.from(this.querySelectorAll('[data-progress-step-number]'))

    this.previousStepButton?.addEventListener('click', () => {
      this.closeCurrentStep();
    })

    this.progressStepItems.forEach(item => {
      item.addEventListener('click', () => {
        const currentStep = this.dataset.currentStep;
        if (+currentStep > +item.dataset.progressStepNumber || currentStep === 'final') {
          this.setAttribute('data-current-step', +item.dataset.progressStepNumber);
        }
      });
    });
  }

  highlightBlock() {
    let currentStep = this.clickedBlock.dataset.step
    let currentStepName = this.clickedBlock.dataset.stepName
    let prevActiveBlock = this.querySelector(`[data-step="${currentStep}"].step-block__item--active`)

    if (prevActiveBlock) {
      prevActiveBlock.classList.remove('step-block__item--active')
    }
    this.clickedBlock.classList.add('step-block__item--active')

    if (currentStepName === 'type') {
      this.querySelectorAll('.step-block__item--active').forEach(activeElement => {
        activeElement.classList.remove('step-block__item--active')
        this.querySelector('[data-step-name="product"]')?.closest('.step-block')?.classList.remove('step-block--active')
      })
      this.isFinalBlock = false
    }

    if (currentStepName === 'roast') {
      this.isFinalBlock = false
    }

    if (prevActiveBlock) {
      prevActiveBlock.classList.remove('step-block__item--active')
    }
    this.clickedBlock.classList.add('step-block__item--active')

    if (currentStepName === 'product') {
      let productItem = this.querySelector('[data-step-name="product"].step-block__item--active')
      let prevProduct = this.querySelector('.final-step__product--active')

      if (prevProduct) {
        prevProduct.classList.remove('final-step__product--active')
      }
      productItem.classList.add('final-step__product--active')

      this.setButtonPrice(productItem);
    }

    this.openNextStep()
    if (this.stepProgressWrapper) {
      window.scrollTo({ top: this.stepProgressWrapper.offsetTop - 62, behavior: 'smooth' });
    }
  }

  closeCurrentStep() {
    if (this.dataset.currentStep == 'final' || this.dataset.currentStep == '4') {
      this.dataset.currentStep = this.clickedBlock.dataset.step;
      this.querySelector('.landing-product__final').classList.remove('active');
      this.querySelector(['[data-step-name="product"].step-block__item--active']).classList.remove('step-block__item--active');
    } else {
      let currentStepWrapper = this.querySelector(`[data-step="${this.dataset.currentStep}"]`);
      this.dataset.currentStep == 2 ? this.previousStepButton.classList.remove('active') : null;
      currentStepWrapper?.closest('.landing-product__step').classList.remove('step-block--active', 'step-block--default-variant-active');
      this.dataset.currentStep = Math.max(this.dataset.currentStep - 1, 1);
    }

    if (this.stepProgressWrapper) {
      window.scrollTo({ top: this.stepProgressWrapper.offsetTop - 62, behavior: 'smooth' });
    }
  }

  static get observedAttributes() {
    return ["data-current-step"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-current-step") {
      this.handleStepChange(newValue);
    }
  }

  handleStepChange(newStep) {
    let allSteps = this.querySelectorAll('.landing-product__step');
    let finalStep = this.querySelector('.landing-product__final');
    let currentStep = this.querySelector(`[data-step="${newStep}"]`)?.closest('.landing-product__step');

    if (newStep == '4' || newStep == 'final') {
      allSteps.forEach(step =>  {
        if (!step.contains(this.querySelector('[data-step-name="product"]'))) {
          step.classList.remove('step-block--active', 'step-block--default-variant-active');
        }
      });
      finalStep.classList.add('active');
    } else {
      allSteps.forEach(step => step.classList.remove('step-block--active', 'step-block--default-variant-active'));
      finalStep.classList.remove('active');
      currentStep.classList.add('step-block--active');
    }

    this.updateStepsProgress(newStep);
  }

  updateStepsProgress(currentStepIndex) {
    const steps = document.querySelectorAll(".step-progress");

    if (currentStepIndex == 'final' || currentStepIndex == '4') {
      steps.forEach(step => {
        step.classList.add("completed");
      });
      return;
    }

    steps.forEach((step, index) => {
      if (index < currentStepIndex - 1) {
        step.classList.add("completed");
        step.classList.remove("active");
      } else if (index === +currentStepIndex - 1) {
        step.classList.add("active");
        step.classList.remove("completed");
      } else {
        step.classList.remove("active", "completed");
      }
    });
  }
}

if (!customElements.get('landing-product-double-new')) {
  customElements.define('landing-product-double-new', LandingProductDoubleSectionNew);
}
